import { HowTo } from "/react4xp/parts/how-to/how-to";

export default (props) => <HowTo {...props} />